// tanstack
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/$accountId/_user/energyxplorer/portfolio/',
)({
  beforeLoad: () =>
    redirect({
      to: 'overview/standard',
      replace: true,
    }),
});
